import { render, staticRenderFns } from "./script-edit.vue?vue&type=template&id=45382648&"
import script from "./script-edit.vue?vue&type=script&lang=js&"
export * from "./script-edit.vue?vue&type=script&lang=js&"
import style0 from "./script-edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports